// extracted by mini-css-extract-plugin
export default {"bg":"Event_bg__mnJQa"};